import React, { useEffect, useState } from 'react'
import RecruiterDashboardHeader from '../Components/RecruiterDashboardHeader'
import RecruiterHeaderComponent from '../Components/RecruiterHeaderComponent'
import CandidateCardForRecruiter from '../Components/CandidateCardForRecruiter'
import { CandidateProfile, CandidateTotalCountResponse } from '../../Candidate/Types/CandidateType';
import { getAllCandidates, getCandidatesTotalStats } from '../../Candidate/Services/CandidateService';
import { getJobTemplateByCompanyRecruiterId } from '../../JobPostTemplate/Services/JobPostTemplateService';
import HorizontalFilterBar from '../../SearchFilter/Components/HorizontalFilterBarComponent';
import { getAllSavedFiltersCompany, getAllSavedFiltersUser, getAllSearchFilters, getAllSearchFiltersBySubscriptionPlan } from '../../SearchFilter/Services/SearchFilterService';
import SmartFilterSystemPage from '../../SearchFilter/Pages/SmartFilterSystemPage';
import QuickSmartFilterSystem from '../../SearchFilter/Components/QuickSmartFilterSystem';
import LoadMoreButton from '../../Shared/Pagination/LoadMoreButton';
import { SavedFilterResponse, SearchFilterResponse } from '../../SearchFilter/Types/SerachFileter';
import { storage } from '../../Shared/Utils/authStorage';
import { CandidateSearch } from '../Components/CandidateSearch';
import ExecutiveSearchPortalLight from '../SearchComponents/ExecutiveSearchPortalLight';

function RecruiterCandidateListingPage() {


   const [filterBySubscriptionPlan, setFilterBySubscriptionPlan] = useState<SearchFilterResponse []>([]);
   const [candidatesStats, setCandidatesStats] = useState<CandidateTotalCountResponse>();
   const [savedFiltersByUser, setSavedFiltersByUser] = useState<SavedFilterResponse[]>();
   const [savedFiltersByCompany, setSavedFiltersByCompany] = useState<SavedFilterResponse[]>();



    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [page, setPage] = useState(0);

    const [pagination, setPagination] = useState({
      page: 0,
      size: 2,
      totalElements: 0,
      totalPages: 0,
      first: true,
      last: false,
      hasNext: false,
      hasPrevious: false,
    });


      useEffect(() => {
              const fetchCandidate = async () => {
                try {
                  setLoading(true); // Ensure loading is true when starting
                  const response = await getAllSearchFiltersBySubscriptionPlan(storage.getUserId() ?? "");
                  const candidateTotalStats = await getCandidatesTotalStats();
                  const savedFilterByUsers = await getAllSavedFiltersUser(page);
                  const savedFilterByComapny = await getAllSavedFiltersCompany(page);


                    
                  if (response.success) {
                    setFilterBySubscriptionPlan(response.data);
                    setCandidatesStats(candidateTotalStats.data)
                    setSavedFiltersByUser(savedFilterByUsers.data.content)
                    setSavedFiltersByCompany(savedFilterByComapny.data.content)
                  } else {
                    setError(response.message || "Could not retrieve recruiter profile.");
                  }
                } catch (err) {
                  setError("An unexpected error occurred while loading the profile.");
                  console.error(err);
                } finally {
                  setLoading(false);
                }
              };
            
              fetchCandidate();
            }, []); // Empty dependency array is fine if using localStorage



  return (
    <div>
  {/* <RecruiterHeaderComponent /> */}


  {/* <QuickSmartFilterSystem/> */}

  {/* <QuickSmartFilterSystem
      filters={adminData}
    /> */}

    {/* <CandidateSearch searchFilterData={adminData} candidatesTotalStats={candidatesStats}/> */}

    <CandidateSearch searchFilterData={filterBySubscriptionPlan} candidatesTotalStats={candidatesStats} 
    savedSearchFilterDtaByUser={savedFiltersByUser}
    savedSearchFilterDtaByCompany={savedFiltersByCompany}
    />


    {/* <ExecutiveSearchPortalLight/> */}

  

</div>
  )
}

export default RecruiterCandidateListingPage